import { useCallback, useEffect, useState } from "react";
import { request } from "../../httpClient";

export const useArticleList = () => {
  const [articleList, setArticleList] = useState([]);
  const [articleListLoading, setArticleListLoading] = useState(false);

  const getArticleList = useCallback(async () => {
    setArticleListLoading(true);
    const res = await request({
      path: "article/list",
    });
    setArticleList(res?.data || []);
    setArticleListLoading(false);
  }, []);

  useEffect(() => {
    getArticleList();
  }, [getArticleList]);

  return { articleList, articleListLoading, getArticleList };
};
